export default (anamnesis) => {
    if (!anamnesis.formData) {
        anamnesis.formData = {}
    }

    if (!anamnesis.formData.teethIndication) {
        anamnesis.formData.teethIndication = {}
    }

    if (!anamnesis.formData.additionalIndication) {
        anamnesis.formData.additionalIndication = null
    }

    if (!anamnesis.formData.treatmentExpectation) {
        anamnesis.formData.treatmentExpectation = []
    }
    return anamnesis
}



// WEBPACK FOOTER //
// ./src/modules/anamnesis/state/anamnesis/initialize-aligner-treatment-physician-assesment.js